module.exports = __webpack_public_path__ + "static/media/bg-login.54dc1b8b.jpg";